// react
import { lazy } from 'react';

import BridgeLayout from 'layout/BridgeLayout';
import Loadable from 'components/Loadable';

const Bridge = Loadable(lazy(() => import('pages/Bridge')));
const Terms = Loadable(lazy(() => import('pages/Bridge/terms')));

const BridgeRoutes = {
  path: '/bridgewifi',
  element: <BridgeLayout />,
  children: [
    {
      path: '',
      element: <Bridge />
    },
    {
      path: 'terms',
      element: <Terms />
    }
  ]
};

export default BridgeRoutes;
